import React from "react";

import { Button, Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean } from "../ds/client_ds";
import {
  FabricStyleBean,
  FabricStyleSKUBean,
  FabricStyleWebExportInputBean,
  PageListBean,
  RestFabricStyleListBeanRequest,
  RestFabricStyleListRequest,
  RestReadRequest,
  RestSimpleItemBeanRequest,
  WebSkuInventorySearchCriteria,
} from "../ds/ds.js";
import { DeleteIcon } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  CollapseComponent,
  DataGridColumnDefinition,
  EditableDataGrid,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler";
import { PopupFabricStyleModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { ECommerceConnectorService } from "../services/ECommerceConnectorService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { ReportService } from "../services/ReportService.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
} from "./BaseModule.js";

class WebSkuInventoryExport extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Web Sku Inventory Export",
      isShowClearErrorButton: false,
      isShowToolBarButton: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      isShowExecuteButton: false,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowFabricModule: false,
      moduleForPopup: [],
      error_list: [],
      webSkuInventoriesDataList: [],
      selectedRowDataList: [],
      isFabricStyleDataFound: false,
      fabricCriteriaList: [],
      isShowSelectAllButton: false,
      isShowUnSelectAllButton: false,
      isShowWebExportButton: false,
      isShowExportAsItemBUutton: false,
      isCollapsible_open: true,
      summaryData: null,
      criteria: new WebSkuInventorySearchCriteria(),
      fabricPageListForAutoCompleteList: new Array(),
      fabricColourPageListForAutoCompleteList: new Array(),
      criteriaViewShow: false,
      pageList: new PageListBean(),
      isShowPageListToolBar: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      fabricStyleData: new FabricStyleBean(),
      isShowAutoCompleteList: true,
      showAutoCompleteFabricColorList: true,
      isShowFabricStyleModule: false,
      fileName: "",
      isShowWebExportPopup: false,

      webExportItems: [],
      targetWebsites: [],
      selectedTargetWebsites: [],
      ItemCodes: [],
      colors: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      colorsList: [],
      is3PL: false,
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };
    let targetWebsites = attribute_cache.targetWebSiteDetails;
    if (targetWebsites != null && targetWebsites != "undefined") {
      targetWebsites.map((list) => {
        this.state.targetWebsites.push(list);
      });
    }
    this.initLookupHandlers();
  }

  componentDidUpdate() {
    //
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = this.state.success_list;
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };

  loadPage = (pageNumber) => {
    this.clearError();
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    let listRequest = new RestFabricStyleListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.pageInput = pageInput;
    this.loadFabricStylePageList(listRequest);
  };

  loadFabricStylePageList = (listRequest) => {
    if (SecurityAccessManager.WebSKUInventoryExport_IsAccessible()) {
      InventoryService.getWebSkuInventories(
        listRequest,
        this.loadWebSkuInventorieseListResponse,
        this.loadWebSkuInventoriesPageListError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  loadWebSkuInventorieseListResponse = (response) => {
    const inventoryPageList = response.data.inventoryPageList.webSkuInventories;
    let fabricStylepageList = response.data.inventoryPageList;
    let pageList = this.state.pageList;
    pageList.currentPage = fabricStylepageList.currentPage;
    pageList.pageSize = fabricStylepageList.pageSize;
    pageList.totalCount = fabricStylepageList.totalCount;

    if (inventoryPageList != null) {
      this.setState({
        isFabricStyleDataFound: true,
        webSkuInventoriesDataList: inventoryPageList,
        pageList: pageList,
        isShowPDFButton: false,
        isShowExcelButton: false,
      });
    } else {
      let errMsg = "No data Found";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      this.setState({
        isFabricStyleDataFound: false,
        isShowPageListToolBar: false,
      });
    }
    this.setState({
      isLoading: false,
    });
  };

  loadWebSkuInventoriesPageListError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };

  clearError = () => {
    this.setState({ error_list: [] });
  };

  clearCriteria = () => {
    let tempCriteria = new WebSkuInventorySearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.fabricStyleName = "";
    this.setState({
      criteria: tempCriteria,
      fabricCriteriaList: [],
      isCollapsible_open: true,
    });
  };

  reset = () => {
    let tempCriteria = new WebSkuInventorySearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.fabricStyleName = "";
    this.setState({
      criteria: tempCriteria,
      isFabricStyleDataFound: false,
      webSkuInventoriesDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowSelectAllButton: false,
      isShowUnSelectAllButton: false,
      isShowWebExportButton: false,
      isShowExportAsItemBUutton: false,
      isShowClearCriteriaButton: true,
      isCollapsible_open: true,
      isShowToolBarButton: true,
      isShowResetButton: false,
      fabricCriteriaList: [],
    });
  };

  fetch = (e) => {
    if (e.detail === 1) {
      this.setState({
        isLoading: true,
        loadingText: "Executing",
      });
      this.setState({
        isShowSelectAllButton: true,
        isShowUnSelectAllButton: true,
        isShowWebExportButton: true,
        isShowExportAsItemBUutton: true,
        isShowClearCriteriaButton: false,
        isCollapsible_open: false,
        isShowToolBarButton: false,
        isShowResetButton: true,
      });
      this.loadPage(1);
    }
  };

  onFabricCodeChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.isShowFabricAutoCompleteList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.isShowFabricAutoCompleteList;
    if (isEmpty(fabricStyleCode)) {
      this.state.isShowFabricAutoCompleteList = false;
      let showAutoCompleteList = this.state.isShowFabricAutoCompleteList;
      let tempCriteria = this.state.criteria;
      tempCriteria.fabricStyleCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        criteria: tempCriteria,
        fabricPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };

  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.readandsetFabricStyleDetail(e.target.value);
    this.state.isShowFabricAutoCompleteList = false;
    let showAutoCompleteList = this.state.isShowFabricAutoCompleteList;
    this.setState({
      fabricPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };

  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteList: showAutoCompleteList });
  };

  readFabricBySearchString(searchString) {
    let searchCriteria = new WebSkuInventorySearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    if (SecurityAccessManager.WebSKUInventoryExport_IsAccessible()) {
      FabricStyleService.getActiveFabricStylesForAutoComplete(
        input,
        this.readByFabricCodeResponse,
        this.readByFabricCodeResponseError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  }

  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readByFabricCodeResponseError = (error) => {
    ShowError("Error : ", error);
  };

  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL
        ? "Reading Item"
        : "Reading Fabric ",
    });
    FabricStyleService.readFabricStyleWithColors(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.readandsetFabricStyleDetailError
    );
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let fabricStyle = response.data.fabricStyle;
    if (fabricStyle != null) {
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = fabricStyle.code;
      criteria.fabricStyleName = fabricStyle.description;

      let colors = fabricStyle.colors;
      let finalColorList = [];
      colors.map((ent) => {
        let colorBean = new BaseBean();
        colorBean.code = ent.fabricStyleColorCode;
        colorBean.description = ent.fabricStyleColorName;
        finalColorList.push(colorBean);
      });
      this.setState({ colorLookupHandler: null });
      if (finalColorList != null) {
        let colorLookupHandler = new GenericAttributeLookupHandler(
          finalColorList,
          "Color"
        );
        this.setState({
          colorLookupHandler: colorLookupHandler,
          isShowColorLookup: true,
          colorsList: finalColorList,
        });
      }

      this.setState({ fabricStyleData: fabricStyle, criteria: criteria });
    }
    this.setState({ isShowProgressBarPopup: false, progressLoadingText: "" });
  };
  readandsetFabricStyleDetailError = (error) => {
    this.setState({ isShowProgressBarPopup: false, progressLoadingText: "" });
    ShowError("Error : ", error);
  };

  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;

    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
    this.fabricStyleColorSelected(e.target.value);
  };

  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    fabricStyle.fabricStyleSkus.map((sku) => {
      if (
        sku.fabricStyleCode == criteria.fabricStyleCode &&
        sku.fabricStyleColorCode == searchString
      )
        skuBean = sku;
    });
    criteria.colorCode = searchString;
    let colorList = this.state.colorsList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(e.target.value);

    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    fabricStyle.fabricStyleSkus.map((sku) => {
      if (
        sku.fabricStyleCode == criteria.fabricStyleCode &&
        sku.fabricStyleColorCode == colorCode
      )
        skuBean = sku;
    });
    criteria.colorCode = colorCode;

    this.setState({ criteria: criteria });
  };
  selectAll = (e) => {
    if (e.detail === 1) {
      let list = this.state.webSkuInventoriesDataList;
      list.map((line, i) => {
        line.isApplied = true;
      });
      this.setState({ selectedRowDataList: list });
    }
  };
  unSelectAll = (e) => {
    if (e.detail === 1) {
      let list = this.state.webSkuInventoriesDataList;
      list.map((line, i) => {
        line.isApplied = false;
      });
      this.setState({ selectedRowDataList: [] });
    }
  };
  onSelectedChange = (val, rowData) => {
    if (rowData.isApplied === true) {
      let selectedLine = this.state.selectedRowDataList;
      selectedLine.push(rowData);
      this.setState({ selectedRowDataList: selectedLine });
    } else {
      let checkLines = this.state.selectedRowDataList;
      let selectedLine = [];
      for (let line of checkLines) {
        if (line.isApplied != rowData.isApplied) {
          selectedLine.push(line);
          this.setState({ selectedRowDataList: selectedLine });
        }
      }
    }
  };
  viewFabricModule = (code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowFabricStyleModule: true,
        moduleForPopup: (
          <PopupFabricStyleModule
            fabricStyleCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };

  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      moduleForPopup: [],
    });
  };

  selectAllWebFab = (e) => {
    if (e.detail === 1) {
      let list = this.state.targetWebsites;
      list.map((line, i) => {
        line.isApplied = true;
      });
      this.setState({ selectedTargetWebsites: list });
    }
  };
  unSelectAllWebFab = (e) => {
    if (e.detail === 1) {
      let list = this.state.targetWebsites;
      list.map((line, i) => {
        line.isApplied = false;
      });
      this.setState({ selectedTargetWebsites: [] });
    }
  };

  onWebSelectedChange = (val, rowData) => {
    if (rowData.isApplied === true) {
      let selectedLine = this.state.selectedTargetWebsites;
      selectedLine.push(rowData);
      this.setState({ selectedTargetWebsites: selectedLine });
    } else {
      let checkLines = this.state.selectedTargetWebsites;
      let selectedLine = [];
      for (let line of checkLines) {
        if (line.isApplied != rowData.isApplied) {
          selectedLine.push(line);
          this.setState({ selectedTargetWebsites: selectedLine });
        }
      }
    }
  };

  deleteFabricStyle = (line) => {
    let criteria = this.state.criteria;
    let lineData = criteria.fabricStyleCodes;
    let fabricCriteriaList = this.state.fabricCriteriaList;
    fabricCriteriaList.map((list, index) => {
      if (list.code === line.code) {
        lineData.splice(index, 1);
        fabricCriteriaList.splice(index, 1);
      }
    });
    this.setState({ criteria: criteria });
  };
  addFabricStyle = () => {
    let criteria = this.state.criteria;
    let fabricCriteriaList = this.state.fabricCriteriaList;
    let fabricStyleData = this.state.fabricStyleData;
    if (fabricStyleData != null) {
      if (!isEmptyArray(fabricCriteriaList)) {
        let exists = fabricCriteriaList.find(
          (p) => p.code === fabricStyleData.code
        );
        if (!exists) {
          fabricCriteriaList.push(fabricStyleData);
          criteria.fabricStyleCodes.push(fabricStyleData.code);
          this.setState({
            criteria: criteria,
            fabricCriteriaList: fabricCriteriaList,
          });
        }
      } else {
        if (!isEmptyString(fabricStyleData.code)) {
          fabricCriteriaList.push(fabricStyleData);
          criteria.fabricStyleCodes.push(fabricStyleData.code);
          this.setState({
            criteria: criteria,
            fabricCriteriaList: fabricCriteriaList,
            isShowColorLookup: false,
          });
        }
      }
    }
    criteria.fabricStyleName = "";
    this.setState({ criteria: criteria, isShowColorLookup: false });
  };

  onModuleExit = () => {
    this.props.onModuleExit();
  };

  showHideSecondHeader = () => {
    let tempIsCollapsible_open = !this.state.isCollapsible_open;
    this.setState({ isCollapsible_open: tempIsCollapsible_open });
  };

  loadExcelFabric = (e) => {
    let file = e.target.files[0];
    let fileName = file.name;
    let fileData = new File([file], `${fileName}`, { type: file.type });
    let formData = new FormData();
    formData.append("file", fileData);
    this.setState({ fileName: fileName });
    if (SecurityAccessManager.WebSKUInventoryExport_IsAccessible()) {
      FabricStyleService.FabricStyleExcelUpload(
        formData,
        this.fabricStyleExcelUploadResponse,
        this.fabricStyleExcelUploadError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  fabricStyleExcelUploadResponse = (response) => {
    if (response.data != null) {
      if (response.data.success == true) {
        this.getExcelData();
      }
    }
  };
  fabricStyleExcelUploadError = (error) => {
    ShowError("Error : " + error);
  };
  getExcelData = () => {
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = this.state.fileName;
    if (SecurityAccessManager.WebSKUInventoryExport_IsAccessible()) {
      ReportService.getFabricCriteriaExportInputFromExcel(
        request,
        this.getFabricExcelResponse,
        this.getFabricExcelError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  getFabricExcelResponse = (response) => {
    if (response.data != null) {
      if (response.data.einput != null) {
        let fabricCriteriaList = response.data.einput.lines;
        let fabricCodes = [];

        let fabric = fabricCriteriaList
          .filter(
            (fb, ind) =>
              ind ===
              fabricCriteriaList.findIndex(
                (lc) => lc.fabricStyleCode === fb.fabricStyleCode
              )
          )
          .map((list) => {
            let baseBean = new BaseBean();
            baseBean.code = list.fabricStyleCode;
            fabricCodes.push(baseBean);
          });
        this.setState({
          fabricCriteriaList: fabricCodes,
        });
      }
    }
  };
  getFabricExcelError = (error) => {
    ShowError("error :", error);
  };

  loadFirst = () => {
    this.loadPage(1);
  };

  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage;
    if (currentPage < 1) {
      previousPage = currentPage - 1;
    }
    this.loadPage(previousPage);
  };

  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let nextPage = currentPage;
    if (currentPage > totalPages) {
      nextPage = currentPage + 1;
    }
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  WebExport = (e) => {
    if (e.detail === 1) {
      // if (!isEmpty(criteria.items)) {
      this.setState({
        isShowWebExportPopup: true,
      });
    }
    // } else {
    //   let errMsg = "no fabrics selected";
    //   let errList = [];
    //   errList.push(errMsg);
    //   this.setState({
    //     alertMessage: errList,
    //     alertType: "danger",
    //     isShowAlert: true,
    //   });
    // }
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowWebExportPopup: isShowPopup,
    });
  };
  WebExportContinue = (e) => {
    if (e.detail === 1) {
      this.setState({ isShowWebExportPopup: false });
      let criteria = new FabricStyleWebExportInputBean();
      criteria.companyCode = this.companyCode;
      let selectedTargetWebsites = this.state.selectedTargetWebsites;
      let emptyArray = [];
      selectedTargetWebsites.map((list) => {
        let emptyString = list.code + "-" + list.webExportTypCode;
        emptyArray.push(emptyString);
      });
      criteria.exportTypes = emptyArray;
      let selectedRowDataList = this.state.selectedRowDataList;
      let ItemCodes = this.state.ItemCodes;
      selectedRowDataList.map((list) => {
        let SimpleItemBean = new RestSimpleItemBeanRequest();
        SimpleItemBean.code = list.code;
        SimpleItemBean.description = list.description;
        ItemCodes.push(SimpleItemBean);
      });
      criteria.items = ItemCodes;
      criteria.itemListCount = ItemCodes.length;
      if (SecurityAccessManager.WebSKUInventoryExport_IsAccessible()) {
        ECommerceConnectorService.uploadWebSkuInventoriesToEcomConnectorJob(
          criteria,
          this.uploadFabricStylesToEcomConnectorJobResponse,
          this.uploadFabricStylesToEcomConnectorJobError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  uploadFabricStylesToEcomConnectorJobResponse = (response) => {};
  uploadFabricStylesToEcomConnectorJobError = (error) => {
    ShowError("Error : ", error);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowSalesModule: isOpen,
      isShowCustomerModule: isOpen,
      moduleForPopup: [],
    });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  webExportColumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("", "isApplied", 0, false, null, false, null, "2em", "8%")
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.onWebSelectedChange
        )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Website", "code")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Name", "description")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "ExportTypes",
        "webExportTypCode"
      )
    );
    return columnList;
  };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("", "isApplied", 0, false, null, false, null, "2em", "8%")
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.onSelectedChange
        )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.state.is3PL ? "Item" : "FabricStyle#",
        "fabricStyleCode",
        0,
        true,
        this.viewFabricModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.state.is3PL ? "Item Name" : "FabricStyleName#",
        "fabricStyleName"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Color", "fabricStyleColorCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Location", "locationCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("UOM", "uomCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Sku", "skuNumber", 1)
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "WebOnHandQuantity",
        "webOnHandQuantity",
        1
      )
    );
    return columnList;
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  render() {
    let webSkuInventoriesDataList = this.state.webSkuInventoriesDataList;
    let targetWebsites = this.state.targetWebsites;
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowToolBarButton={this.state.isShowToolBarButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.reset}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          extend_toolbar={
            <>
              {this.state.isShowToolBarButton && (
                <Button
                  className="header_buttons secondary"
                  size="sm"
                  onClick={(e) => this.fetch(e)}
                >
                  Fetch
                </Button>
              )}
            </>
          }
        />
        <CriteriaView
          {...this.state}
          fetch={this.fetch}
          loadExcelFabric={this.loadExcelFabric}
          deleteFabricStyle={this.deleteFabricStyle}
          addFabricStyle={this.addFabricStyle}
          showHideSecondHeader={this.showHideSecondHeader}
          onFabricCodeChange={this.onFabricCodeChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteList={this.displayAutoCompleteList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          is3PL={this.state.is3PL}
        />
        {this.state.isFabricStyleDataFound ? (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        ) : null}
        {this.state.isFabricStyleDataFound ? (
          <div>
            <Row>
              <Col sm="1">
                <Button
                  className="header_buttons"
                  size="sm"
                  onClick={(e) => this.selectAll(e)}
                >
                  SelectAll
                </Button>
              </Col>
              <Col sm="1">
                <Button
                  className="header_buttons"
                  size="sm"
                  onClick={(e) => this.unSelectAll(e)}
                >
                  UnSelectAll
                </Button>
              </Col>
              {/* <Col sm="1">
              <Button
                  className="header_buttons"
                  size="sm"
                  onClick={this.exportAsItem}
                >
                  ExportAsItem
                </Button>
              </Col> */}
              <Col sm="1">
                <Button
                  className="header_buttons"
                  size="sm"
                  onClick={(e) => this.WebExport(e)}
                >
                  MultiExport
                </Button>
              </Col>
            </Row>
            <MultiViewPopup
              isShowPopup={this.state.isShowWebExportPopup}
              closeOnEsc={false}
              closeAlertModalCallBack={this.closeAlertModalCallBack}
              title={"Multi Export Selection"}
              closeOnDocumentClick={false}
              lineFunctionalityForm={this.lineFunctionalityForm}
              headerButtonContainer={
                <div className="floatLeft">
                  <div>
                    <Button
                      className="header_buttons enterFocus"
                      size="sm"
                      onClick={(e) => this.WebExportContinue(e)}
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              }
              content={
                <div>
                  <Row>
                    <Col sm="1">
                      <Button
                        className="header_buttons enterFocus"
                        size="sm"
                        onClick={(e) => this.selectAllWebFab(e)}
                      >
                        SelectAll
                      </Button>
                    </Col>
                    <Col sm="1">
                      <Button
                        className="header_buttons enterFocus"
                        size="sm"
                        onClick={(e) => this.unSelectAllWebFab(e)}
                      >
                        UnSelectAll
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <EditableDataGrid
                      columnsList={this.webExportColumnDefinitions()}
                      dataList={targetWebsites}
                    />
                  </Row>
                </div>
              }
            />
            <EditableDataGrid
              columnsList={this.columnDefinitions()}
              dataList={webSkuInventoriesDataList}
            />
          </div>
        ) : null}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}

class CriteriaView extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);

    this.state = {
      criteria: this.props.criteria,
      fabricCriteriaList: this.props.fabricCriteriaList,
      webSkuInventoriesDataList: this.props.webSkuInventoriesDataList,
      isCollapsible_open: this.props.isCollapsible_open,
      colors: [],
    };
    this.fabricColorCodeRef = React.createRef();
    this.fabricStyleCodeRef = React.createRef();
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    this.loadCacheDetails();
    this.setFocus();
  }
  setFocus() {
    if (this.fabricStyleCodeRef.current != null) {
      this.fabricStyleCodeRef.current.focus();
    }
    if (this.fabricColorCodeRef.current != null) {
      this.fabricColorCodeRef.current.focus();
    }
  }

  setClear() {
    let criteria = this.state.criteria;
    criteria.fabricStyleCode = "";
    this.setState({ criteria: criteria });
    this.fabricStyleCodeRef.current.clear();
    this.fabricStyleCodeRef.current.focus();
  }

  displayAutoCompleteList = (e) => {
    this.props.displayAutoCompleteList(e);
  };
  fabricEnterKeyEventHandler = (e) => {
    this.props.fabricEnterKeyEventHandler(e);
  };
  onFabricCodeChange = (e) => {
    this.props.onFabricCodeChange(e);
  };
  loadExcelFabric = (e) => {
    this.props.loadExcelFabric(e);
  };
  addFabricStyle = (e) => {
    if (e.detail === 1) {
      this.props.addFabricStyle();
      this.setClear();
    }
  };
  deleteFabricStyle = (e) => {
    this.props.deleteFabricStyle(e);
  };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) this.props.showHideSecondHeader();
  };
  onFabricColourCodeChange = (e) => {
    this.props.onFabricColourCodeChange(e);
  };
  fabricColourEnterKeyEventHandler = (e) => {
    this.props.fabricColourEnterKeyEventHandler(e);
  };
  displayAutoCompleteFabricColorList = () => {
    this.props.displayAutoCompleteFabricColorList();
  };
  onExcelFabricClick = (e) => {
    if (e.detail <= 1) {
      const input = document.getElementById("file-input");

      if (input) {
        input.click();
      }
    }
  };

  loadCacheDetails = () => {
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };
    let colors = attribute_cache.colors;
    if (colors != null && colors != "undefined") {
      colors.map((list) => {
        this.state.colors.push(list);
      });
    }
  };

  fabricColumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.props.is3PL ? "Item" : "FabricStyleCode#",
        "code",
        0,
        true
      )
    );
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "Remove",
          <DeleteIcon />,
          1,
          false,
          null,
          false,
          null, //image link call back
          "1em", //min-width
          "20%", //max-width
          false,
          null,
          false
        )
        .setEditableDetails(
          false,
          "",
          null,
          true,
          this.deleteFabricStyle,
          false,
          null
        )
    );
    return columnList;
  };

  render() {
    let criteria = this.props.criteria;
    let fabricCriteriaList = this.props.fabricCriteriaList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.props.progressLoadingText}
          isShowPopup={this.props.isShowProgressBarPopup}
        />
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            {" "}
            {this.props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={this.fabricStyleCodeRef}
              onChange={this.onFabricCodeChange}
              name="fabricStyleCode"
              value={criteria.fabricStyleCode}
              lookupRequired={true}
              lookupHandler={this.props.fabricLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.fabricEnterKeyEventHandler}
              autoCompleteListData={
                this.props.fabricPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteList}
              showAutoCompleteList={this.props.showAutoCompleteList}
            />
          </Col>
          <Col sm="1">
            <Button
              size="sm"
              className="header_buttons enterFocus"
              onClick={(e) => this.addFabricStyle(e)}
            >
              Add
            </Button>
          </Col>

          <Col sm="2">
            <InputTextbox
              onChange={this.onFabricCodeChange}
              name="fabricStyleName"
              value={criteria.fabricStyleName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Color</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onFabricColourCodeChange}
              ref={this.fabricColorCodeRef}
              name="colorCode"
              placeholder="Color"
              value={criteria.colorCode}
              lookupRequired={this.props.isShowColorLookup}
              lookupHandler={this.props.colorLookupHandler}
              enterKeyEventHandler={this.fabricColourEnterKeyEventHandler}
              autoCompleteListData={
                this.props.fabricColourPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteFabricColorList}
              showAutoCompleteList={this.props.showAutoCompleteFabricColorList}
            />
          </Col>
          <Col md={0.9}>
            <CollapseComponent
              isOpen={this.props.isCollapsible_open}
              onClick={(e) => this.showHideSecondHeader(e)}
            />
          </Col>
        </Row>

        {this.props.isCollapsible_open && (
          <Row>
            <Col sm="4">
              <EditableDataGrid
                columnsList={this.fabricColumnDefinitions()}
                dataList={fabricCriteriaList}
              />
            </Col>

            <Col sm="2">
              <Button
                id="fabric_Add_Button"
                className="enterFocus"
                size="sm"
                onClick={(e) => this.onExcelFabricClick(e)}
              >
                {this.props.is3PL ? (
                  <FormLabel>LoadExcel Item</FormLabel>
                ) : (
                  <FormLabel>Load Excel FAbric</FormLabel>
                )}
              </Button>
              <input
                type="file"
                id="file-input"
                style={{ display: "none" }}
                onChange={this.loadExcelFabric}
                accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
              />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}
function WebSkuInventoryModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <WebSkuInventoryExport {...props} name="" /> <br />
    </div>
  );
}

export default WebSkuInventoryModule;
